import URL from '../constants/URL';
import dataProxy from '../dataProxy';

export default {
  /**
   * 获取报表列表
   * @returns {Promise<any>}
   */
  getReportList(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.REPORT_LIST, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 获取报表下载数据
   * @returns {Promise<any>}
   */
  getReportDownloadInfo(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .download(URL.REPORT_DOWNLOAD, {
          params,
          responseType: 'arraybuffer',
        })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
};
